(function() {
  // Watch the taggbox container div for changes.
  const taggboxContainer = document.querySelector(".taggbox-container");

  if (!taggboxContainer) {
    return;
  }

  let socialMediaPostsLoaded = false;

  // The observer requires subtree to check for childList.
  const config = { attributes: true };

  // Callback function to look at TaggBox's social media wall.  When the height
  // is greater than the minimum height set for the widget, we hide the loading
  // animation.
  const callback = (mutationsList, observer) => {
    // Use traditional 'for loops' because of IE 11
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes") {
        if (taggboxContainer.style.height === "150px") {
          document
            .querySelector(".taggbox__loading")
            .classList.add("jp-hidden");
          document
            .querySelector(".taggbox__loading")
            .setAttribute("aria-hidden", "true");
          socialMediaPostsLoaded = true;
        }
      }
    }
  };

  const taggboxObserver = new MutationObserver(callback);
  taggboxObserver.observe(taggboxContainer, config);

  if (socialMediaPostsLoaded) {
    taggboxObserver.disconnect();
  }
})();
